/**
 * Equalize heights of items
 *
 * @param {}
 * @return {void}
 */

function equalHeight(items) {
  const itemsHeight = [];
  let itemHeight;
  let maxHeight = 0;

  items.forEach(item => {
    item.style.minHeight = 'auto';
    itemHeight = item.offsetHeight;
    itemsHeight.push(itemHeight);
  })

  for (var i = 0; i < itemsHeight.length; i++) {
    if(maxHeight < itemsHeight[i]) {
      maxHeight = itemsHeight[i]
    }
  }

  items.forEach(item => {
    item.style.minHeight = `${maxHeight}px`;
  })
}

/**
 * Equalize heights of "Product Item Default" content
 */

 window.EQUAL_HEIGHT = equalHeight;

if (window.innerWidth >= 320) {
  $(window).on('load resize', function() {
    setTimeout(function() {
      equalHeight(document.querySelectorAll('.js-eq-item .product-item__content'));
    }, 250);
  });
}
